import axios, { AxiosPromise, CancelTokenSource } from 'axios';
import { getSnakeNewWatcherQueryParams } from '../components/search-decision-watcher/searchWatcherUtils';
import {
  SearchParams,
  SearchAPICount,
  SearchAPIResponse,
  ReportSearchParams,
} from '../search.types';
import { WatcherExistsType } from './reducers/watcherExists.types';

export type ErrorType = { errorMessage?: string; error?: string };

export function ajaxSearch(
  params: SearchParams,
): [AxiosPromise<SearchAPIResponse & ErrorType>, CancelTokenSource] {
  const source = axios.CancelToken.source();

  const promise = axios.get('/ajax_search', {
    params,
    cancelToken: source.token,
  });
  return [promise, source];
}

export function ajaxSearchCount(
  params: SearchParams,
): [
  AxiosPromise<
    SearchAPICount & {
      error: string;
    }
  >,
  CancelTokenSource,
] {
  const source = axios.CancelToken.source();

  const promise = axios.get('/ajax_get_search_count', {
    params,
    cancelToken: source.token,
  });
  return [promise, source];
}

export function checkIfWatcherAlreadyExists(
  params: SearchParams,
): [
  AxiosPromise<
    WatcherExistsType & {
      error: string;
    }
  >,
  CancelTokenSource,
] {
  const source = axios.CancelToken.source();

  const promise = axios.get('/search_watch/already_exists', {
    params: getSnakeNewWatcherQueryParams(params),
    cancelToken: source.token,
  });
  return [promise, source];
}

export const reportSearchEndPoint = (reportData: ReportSearchParams) =>
  axios({
    method: 'POST',
    url: '/report_search',
    data: reportData,
  });
